export default class Convert {
  public static toBoolean(input: string): boolean | undefined {
    try {
      return JSON.parse(input.toLowerCase());
    } catch (e) {
      return undefined;
    }
  }
}
